// STATIC ARRAY CONTAINING INFORMATION FOR NEWSLETTERS
const NEWSLETTER_DATA = [
  // EBB
  {
    header: "Get great deals on ebooks, every day!",
    subheader: "Get <b>great deals</b><br /> on ebooks, <b>every day!</b>",
    headerColor: "white",
    subColor: "white",
    imageURL:
      "https://orion-uploads.openroadmedia.com/newsletter-promo/banner.png",
    refKey: "ebbOptIn",
    logo: "https://orion-uploads.openroadmedia.com/newsletter-promo/ebblogo.png",
    googleLogo:
      "https://orion-uploads.s3.us-east-1.amazonaws.com/newsletter-promo/Google__G__logo.svg.webp",
    content:
      "Sign up for the Early Bird Books newsletter and get the best <br /> daily ebook deals delivered straight to your inbox",
    cardText:
      "Get daily alerts on free and discounted ebooks—bestselling fiction, history, biographies, mysteries, and much more—that you can read on any device!",
    containerColor: "#2e68b2",
    site: "earlybirdbooks",
    optInText: "Subscribe to Early Bird Books!",
    site_id: 1,
    usite_id: 1,
    usite_order: [10, 3, 2, 7, 9, 8, 11],
  },

  // THE LINEUP (TLU)
  {
    header: "THE LINEUP",
    subheader: "Brighten your inbox with a little death and deceit.",
    headerColor: "white",
    subColor: "white",
    bridgeColor: "black",
    imageURL:
      "https://orion-uploads.openroadmedia.com/newsletter-promo/banner.png",
    refKey: "tluOptIn",
    logo: "https://orion-uploads.openroadmedia.com/newsletter-promo/Lineup.png",
    containerColor: "#000000",
    content:
      "Sign up for The Lineup's newsletter and get our most mysterious stories sent straight to your inbox. As a thank you for subscribing, you'll receive a FREE copy of \"The Creepy Collection,\" our mini-book that contains 23 of our eeriest tales.",
    cardText:
      "Keep it creepy. Sign up for The Lineup’s newsletter and receive our eeriest tales, from the best in true crime and horror to encounters with the paranormal.",
    site: "the-line-up",
    optInText: "Subscribe to The Lineup!",
    site_id: 2,
    usite_id: 2,
    usite_order: [1, 3, 7, 9, 8, 10, 11],
  },

  // THE PORTALIST
  {
    header: "THE PORTALIST",
    subheader: "The galaxy's greatest newsletter",
    headerColor: "white",
    subColor: "white",
    imageURL:
      "https://orion-uploads.openroadmedia.com/newsletter-promo/banner.png",
    refKey: "portalistOptIn",
    logo: "https://orion-uploads.openroadmedia.com/newsletter-promo/Portalist.png",
    containerColor: "#3c7d9a",
    content:
      "Sign up and get out-of-this-world sci-fi and fantasy sent straight to your inbox",
    cardText:
      "Explore the best in science fiction and fantasy-and enjoy our unique take on everything from pop culture and books to science and the future of our species.",
    site: "theportalist",
    optInText: "Subscribe to The Portalist!",
    site_id: 3,
    usite_id: 3,
    usite_order: [1, 2, 7, 10, 9, 8, 11],
  },

  // MURDER & MAYHEM (MM)
  {
    header: "MURDER & MAYHEM",
    subheader: "Can you stand the suspense?",
    headerColor: "white",
    subColor: "white",
    imageURL:
      "https://orion-uploads.openroadmedia.com/newsletter-promo/banner.png",
    refKey: "murdermayhemOptIn",
    logo: "https://orion-uploads.openroadmedia.com/newsletter-promo/murderandmyth.png",
    containerColor: "#101010",
    content:
      "Sign up for Murder & Mayhem's FREE newsletter and get our most mysterious and thrilling stories sent straight to your inbox.",
    cardText:
      "You just found your new hideout. Murder & Mayhem delivers the best in mystery and thrillers straight to your inbox.",
    site: "murder-mayhem",
    optInText: "Subscribe to Murder & Mayhem!",
    site_id: 7,
    usite_id: 7,
    usite_order: [1, 2, 10, 9, 3, 8, 11],
  },

  // THE ARCHIVE (ARC)
  {
    header: "THE ARCHIVE",
    subheader: "History is waiting to be discovered.",
    headerColor: "white",
    subColor: "white",
    imageURL:
      "https://orion-uploads.openroadmedia.com/newsletter-promo/banner.png",
    refKey: "archiveOptIn",
    logo: "https://orion-uploads.openroadmedia.com/newsletter-promo/Archive.png",
    containerColor: "#C7B299",
    content:
      "Sign up for The Archive's free newsletter and receive little-known chapters from the past delivered straight to your inbox.",
    cardText:
      "Sign up for The Archive's newsletter, and get our most fascinating stories delivered straight to your inbox.",
    optInText: "Subscribe to The Archive!",
    site_id: 9,
    usite_id: 9,
    usite_order: [1, 2, 7, 10, 3, 8, 11],
    site: "explorethearchive",
  },

  // A LOVE SO TRUE (ALST)
  {
    header: "A LOVE SO TRUE",
    subheader: "Want more romance? No need to beg!",
    headerColor: "white",
    subColor: "white",
    imageURL:
      "https://orion-uploads.openroadmedia.com/newsletter-promo/banner.png",
    refKey: "alovesotrueOptIn",
    logo: "https://orion-uploads.openroadmedia.com/newsletter-promo/loveso.png",
    containerColor: "#e1576b",
    content:
      "Sign up for our newsletter, and get the best in swoon-worthy stories delivered straight to your inbox.",
    cardText:
      "Want more romance? No need to beg! Sign up for our newsletter, and get the best in swoon-worthy stories delivered straight to your inbox.",
    site: "alovesotrue",
    optInText: "Subscribe to A Love So True!",
    site_id: 8,
    usite_id: 8,
    usite_order: [1, 10, 7, 3, 2, 9, 11],
  },

  // YOUNG READERS
  {
    header: "YOUNG READERS",
    refKey: "youngreadersOptIn",
    logo: "https://orion-uploads.openroadmedia.com/newsletter-promo/youngrender_2.png",
    containerColor: "#e63c2f",
    content:
      "Fun features and information about outstanding reads for children and teens—perfect for parents, educators, and librarians.",
    cardText:
      "Fun features and information about outstanding reads for children and teens—perfect for parents, educators, and librarians.",
    site: "earlybirdbooks",
    lists: ["Open Road Young Readers"],
    shouldSendEmail: false,
    optInText: "Subscribe to Young Readers!",
    disclaimerText:
      "By entering your email, you confirm that you are over the age of 13 and agree to receive information and updates about Young Readers. You can withdraw consent at any time.",
    site_id: -1,
    usite_id: 11,
  },

  // THE READER
  {
    header: "THE READER",
    refKey: "theReaderOptIn",
    logo: "https://orion-uploads.openroadmedia.com/newsletter-promo/The_reader.png",
    containerColor: "#0e7ab0",
    content:
      "Get the latest book recommendations and news sent straight to your inbox!",
    site: "ebbreader",
    optInText: "Subscribe to The Reader!",
    cardText:
      "Get the latest book recommendations and news sent straight to your inbox!",
    site_id: -1,
    usite_id: 10,
  },

  // ORM / Catalogue
  {
    header: "Sign Up For Our Early Bird Books Newsletter",
    subheader: "Sign Up For Our Early Bird Books Newsletter",
    content:
      "Enjoy captivating stories, extraordinary experiences, and great deals on classic and undiscovered ebooks",
    imageURL:
      "https://orion-uploads.openroadmedia.com/newsletter-promo/banner.png",
    site: "catalogue",
    site_id: 6,
    usite_id: 6,
    usite_order: [1, 2, 3, 7, 10, 9, 8, 11],
  },
];

module.exports = NEWSLETTER_DATA;
